<div class="summary summary-toggle">
  <div class="row">
    <div class="col-12 font-size-x2 text-interactive text-right" (click)="showPeopleCards = !showPeopleCards">
      <i *ngIf="showPeopleCards" class="fas fa-caret-up"></i>
      <i *ngIf="!showPeopleCards" class="fas fa-caret-down"></i>
      <i class="fas fa-user font-size-x1"></i>
    </div>
  </div>
</div>

<div class="people-container" [ngClass]="{'people-container-hide': !showPeopleCards}">
  <div class="summary">
    <ng-container *ngIf="loading; else driverSummaryContent">
      <app-skeleton-loader variant="driver-summary"></app-skeleton-loader>
    </ng-container>

    <ng-template #driverSummaryContent>
      <mat-card class="driver-summary-card">
        <div class="driver-summary-card__header">
          <img mat-card-avatar class="driver-summary-card__avatar" *ngIf="!!driver?.profilePictureUrl; else defaultImage"
            [src]="driver.profilePictureUrl" />
          <ng-template #defaultImage>
            <img mat-card-avatar class="driver-summary-card__avatar" src="/assets/svg/icons/icon-profile.png" />
          </ng-template>
          <div class="driver-summary-card__title">
            <mat-card-title class="titles title-name">{{ driver?.information?.name || 'Conductor sin información' }}</mat-card-title>
            <mat-card-subtitle class="titles">Conductor</mat-card-subtitle>
          </div>
        </div>

        <mat-card-content class="driver-summary-card__content" *ngIf="showPersonalInformation">
          <section class="driver-summary-card__section">
            <div class="driver-summary-card__section-title">Información Básica</div>
            <div class="driver-summary-card__grid">
              <div class="driver-summary-card__item">
                <i class="color-secondary-dark fas fa-address-card"></i>
                <span class="driver-summary-card__label">Documento</span>
                <span class="driver-summary-card__value">{{ driver?.information?.documentTypeName || '-' }}</span>
              </div>
              <div class="driver-summary-card__item">
                <i class="color-secondary-dark fas fa-hashtag"></i>
                <span class="driver-summary-card__label">Número</span>
                <span class="driver-summary-card__value">{{ driver?.information?.document || '-' }}</span>
              </div>
              <div class="driver-summary-card__item">
                <i class="color-secondary-dark fas fa-phone"></i>
                <span class="driver-summary-card__label">Teléfono</span>
                <span class="driver-summary-card__value">{{ driver?.phone ? (driver.phone | phoneNumber) : '-' }}</span>
                <button type="button" class="driver-summary-card__small-action" *ngIf="driver?.phone"
                  (click)="utils.copyMessage(driver.phone)">
                  Copiar
                </button>
              </div>
              <div class="driver-summary-card__item">
                <i class="color-secondary-dark fas fa-truck"></i>
                <span class="driver-summary-card__label">Vehículo</span>
                <span class="driver-summary-card__value">{{vehicle?.id || '-'}}</span>
                <button type="button" class="driver-summary-card__small-action" *ngIf="vehicle"
                  (click)="vehicleManager.updateInformation(vehicle)">
                  Ver detalles
                </button>
              </div>
            </div>
          </section>

          <section class="driver-summary-card__section">
            <div class="driver-summary-card__section-title">GPS</div>
            <div class="driver-summary-card__grid">
              <div class="driver-summary-card__item">
                <i class="color-secondary-dark fas fa-map-marker-alt"></i>
                <span class="driver-summary-card__label">Proveedor</span>
                <span class="driver-summary-card__value">{{vehicle?.gps?.gpsType || '-'}}</span>
                <button type="button" class="driver-summary-card__small-action" *ngIf="vehicle?.gps?.gpsType"
                  (click)="openGPSSite(vehicle?.gps)">
                  Abrir sitio
                </button>
              </div>
              <div class="driver-summary-card__item">
                <i class="color-secondary-dark fas fa-user"></i>
                <span class="driver-summary-card__label">Usuario</span>
                <span class="driver-summary-card__value">{{ vehicle?.gps?.userGps ? vehicle.gps.userGps : '-' }}</span>
                <button type="button" class="driver-summary-card__small-action" *ngIf="vehicle?.gps?.userGps"
                  (click)="copy(vehicle?.gps?.userGps)">
                  Copiar
                </button>
              </div>
              <div class="driver-summary-card__item">
                <i class="color-secondary-dark fas fa-unlock"></i>
                <span class="driver-summary-card__label">Contraseña</span>
                <span class="driver-summary-card__value">{{ vehicle?.gps?.passwordGps ? vehicle.gps.passwordGps : '-' }}</span>
                <button type="button" class="driver-summary-card__small-action" *ngIf="vehicle?.gps?.passwordGps"
                  (click)="copy(vehicle?.gps?.passwordGps)">
                  Copiar
                </button>
              </div>
              <div class="driver-summary-card__item" *ngIf="vehicle?.gps?.isPortableUnit">
                <i class="color-secondary-dark fas fa-map-pin"></i>
                <span class="driver-summary-card__label">Tipo</span>
                <span class="driver-summary-card__value">{{ vehicle?.gps?.isPortableUnit ? 'Unidad portable': 'Unidad integrada' }}</span>
              </div>
              <div class="driver-summary-card__item" *ngIf="vehicle?.gps?.isPortableUnit">
                <i class="color-secondary-dark fas fa-fingerprint"></i>
                <span class="driver-summary-card__label">ID GPS</span>
                <span class="driver-summary-card__value">{{ vehicle?.gps?.gpsId || '-' }}</span>
                <button type="button" class="driver-summary-card__small-action" *ngIf="vehicle?.gps?.gpsId"
                  (click)="copy(vehicle?.gps?.gpsId)">
                  Copiar
                </button>
              </div>
            </div>
          </section>

          <div class="driver-summary-card__actions">
            <!-- *ngIf="cargo?.secondDriver && !cargo?.activeSecondDriver" -->
            <button *ngIf="cargo?.secondDriver && !cargo?.secondDriverActive" permission-display
              [module]="permission.cargo.module" [functionality]="permission.cargo.activateSecondDriver"
              mat-raised-button class="m-0 secondary-sharp summary__actions col-12 cursor-pointer" color="primary"
              (click)="getDriver()">
              <div><span>Activar segundo conductor</span></div>
            </button>
          </div>

        </mat-card-content>
      </mat-card>
    </ng-template>
  </div>
</div>
